/**
 * Tiny className concat — no `clsx`/`tailwind-merge` dependency.
 * For our hand-written components, we keep classes deduped at write time.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
